import { render, staticRenderFns } from "./CommentMentions.vue?vue&type=template&id=e8d7206a&scoped=true"
import script from "./CommentMentions.vue?vue&type=script&lang=js"
export * from "./CommentMentions.vue?vue&type=script&lang=js"
import style0 from "./CommentMentions.vue?vue&type=style&index=0&id=e8d7206a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d7206a",
  null
  
)

export default component.exports